//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'

//#endregion

import { CommonHelper, ToastHelper, LocalizationHelper, ConvertHelper, LogHelper, TypeHelper, MapHelper, DataTypeGroupComponent } from '../../helpers'

import { OpTask, OpLocationEquipment, OpViewColumn, OpDataTypeInGroup, OpOperator } from '../../models/core'
import { OpFile, OpDevice, OpView } from '../../models/core'
import { OpTaskPaymentElement } from '../../models/custom/op-task-payment-element'

import { Enums } from '../../models/common'
import { ColumnModel } from "../../modules/api/api.models"

import { CreateEditInitParams, BulkEditInitParams } from '../../modules/common/create-edit-popup/create-edit-popup.controller'

import { USER_SESSION_SERVICE_NAME, UserSessionService } from '../user-session'
import { PaymentSubmitResult } from '../../modules/common/payments/payments.interfaces'
import { GetViewColumnOptions } from '../../models/core/op-view'
import { OperatorLayoutSetting } from '../../models/local'
import { MapService, MAP_SERVICE_NAME } from '../../modules/common/map2'
import { GridService, GRID_SERVICE_NAME } from '../grid'
import { OpChangeState } from '../../models/common/enums'
import { ObjectCustomString } from '../../models/util'
import { DataProviderRequest } from '../../data-provider'

//#region Consts

export const TASK_SERVICE_NAME: string = 'TaskService'
export const TASK_SERVICE_PROVIDER_NAME: string = 'TaskServiceProvider'

//#endregion

export class TaskService {

    //#region Consts

    public static get LOG_PREFIX(): string { return '[SIMAX.Module.Task]' }
    public static get FILE_NAME_PREFIX(): string { return 'tasks' }
    public static get REFERENCE_TYPE(): Enums.ReferenceType { return Enums.ReferenceType.IdTask }
    public static get SIMAX_MODULE_NAME(): Enums.SimaxModuleName { return Enums.SimaxModuleName.Task }

    //#endregion


    //#region Ctor

    constructor(private userSessionService: UserSessionService, private mapService: MapService, private gridService: GridService) { }

    //#endregion

    //#region Columns

    private getCurrencyViewColumnName(): JQueryPromise<string> {
        return this.userSessionService
            .getDataProvider()
            .View
            .getActiveView(Enums.ReferenceType.IdTask)
            .then((view: OpView) => {
                const colum: OpViewColumn = view.getViewColumn(new GetViewColumnOptions(Enums.DataType.DISTRIBUTOR_DEFAULT_CURRENCY_ID))
                return colum != null ? colum.name : null
            })
    }

    public getDeviceSerialNumberColumnName(): JQueryPromise<string> {
        return this.userSessionService
            .getDataProvider()
            .View
            .getActiveView(Enums.ReferenceType.SerialNbr)
            .then((view: OpView) => {
                const column: OpViewColumn = view.getViewColumn(new GetViewColumnOptions(Enums.DataType.HELPER_SERIAL_NBR))

                return column != null ? column.name.toLowerCase() : null
            })
    }

    public getEquipmentColumns(): ColumnModel[] {
        const device: ColumnModel = new ColumnModel()
        device.name = 'Device'
        device.idName = 'Device'
        device.caption = LocalizationHelper.getLocalizedText('Device')

        const meter: ColumnModel = new ColumnModel()
        meter.name = 'Meter'
        meter.idName = 'Meter'
        meter.caption = LocalizationHelper.getLocalizedText('Meter')

        const startTime: ColumnModel = new ColumnModel()
        startTime.name = 'StartTime'
        startTime.idName = 'StartTime'
        startTime.caption = LocalizationHelper.getLocalizedText('StartTime')
        startTime.type = Enums.DataTypeClass.Datetime

        return [device, meter, startTime]
    }

    public getInstalledEquipmentParameters(): JQueryPromise<ColumnModel[]> {
        return this.gridService
            .getColumnModelByCategory(
                Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__INSTALLED_DEVICES_GRID_PARAMS,
                Enums.SimaxModuleName.Task,
                { viewReferenceType: Enums.ReferenceType.SerialNbr }
            )
    }

    public getMainGridColumns(): JQueryPromise<ColumnModel[]> {
        return this.gridService
            .getColumnModelByCategory([
                Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__GRID_PARAMS,
                Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__DEFAULT_GRID_PARAMS
            ], TaskService.SIMAX_MODULE_NAME,
                {
                    groupReferenceType: Enums.ReferenceType.IdProfile
                })
    }

    //#endregion

    //#region Get

    public getCurrency(referenceObject: OpTask): JQueryPromise<string> {
        return this.getCurrencyViewColumnName()
            .then((name: string) => {
                const currencyDynamicValue = _.find(referenceObject.dynamicValues, (dynamicValue => dynamicValue.Key == name))

                return currencyDynamicValue != null ? currencyDynamicValue.Value : TypeHelper.emptyString
            })
    }

    public getBasicParametersDataTypeGroup(): JQueryPromise<OpDataTypeInGroup[]> {
        return DataTypeGroupComponent
            .getDataTypeInGroupByModule(
                this.userSessionService.getDataProvider(),
                Enums.SimaxDataTypeGroupCategory.WEBSIMAX__MODULE_NAME__PANEL_PARAMS_TO_DISPLAY,
                TaskService.SIMAX_MODULE_NAME
            )
    }

    public getFitterDevices(): JQueryPromise<OpDevice[]> {
        return this.getOperatorDepositoryContent()
            .then((locationEquipment: OpLocationEquipment[]) => {
                return locationEquipment.map((equipment: OpLocationEquipment) => equipment.device)
            })
    }

    public getMainGridDataSourceParser(): any {
        return (task: OpTask) => {
            if (task == null) {
                return null
            }

            const additionalFieldsObj: { additionalFields: { key: string, value: any }[] } = {
                additionalFields: []
            }

            // LAT LONG COLS
            if (task.dynamicValues != null) {
                const view: OpView = this.userSessionService
                    .getDataProvider()
                    .View
                    .getActiveViewLocal(TaskService.REFERENCE_TYPE)

                const coords: number[] = this.mapService.getCoords(task, { view: view })
                if (_.size(coords) > 1) {

                    const [latitude, longitude] = coords

                    additionalFieldsObj.additionalFields.push({
                        key: MapHelper.LatitudeFieldName,
                        value: latitude
                    })

                    additionalFieldsObj.additionalFields.push({
                        key: MapHelper.LongitudeFieldName,
                        value: longitude
                    })
                } else {
                    additionalFieldsObj.additionalFields.push({
                        key: MapHelper.LatitudeFieldName,
                        value: null
                    })

                    additionalFieldsObj.additionalFields.push({
                        key: MapHelper.LongitudeFieldName,
                        value: null
                    })
                }
            }
            // MARKER TOOLTIP
            const markerFormat: string = ObjectCustomString.getCutomMarkerStringFormat(task)

            if (markerFormat != null) {
                additionalFieldsObj.additionalFields.push({
                    key: MapHelper.MarkerStringFieldName,
                    value: ObjectCustomString.getObjectCustomString(markerFormat, task)
                })
            }

            return additionalFieldsObj
        }
    }

    public getOperatorDepositoryContent(): JQueryPromise<OpLocationEquipment[]> {
        return this.userSessionService
            .getDataProvider()
            .Operator
            .getOperatorDepositoryContent(this.userSessionService.getIdLoggedOperator(), false)
    }

    public getSavedFitterIds(): any[] {
        return this.userSessionService.getOperatorLayoutSetting(new OperatorLayoutSetting(Enums.SimaxOperatorLayoutSetting.ServicemansSelection), [])
    }

    public getTask(idTask: number): DataProviderRequest<OpTask> {
        const promise: DataProviderRequest<OpTask> = this.userSessionService
            .getDataProvider().Task
            .getTask(idTask)

        promise.then((task: OpTask) => {
            if (task != null) {
                return task;
            }

            return $.Deferred().reject(null).promise()
        })

        promise.catch((error: any) => {
            ToastHelper.showError(ConvertHelper.getRequestErrorMessage(error) || LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ExceptionOccuredPleaseContactAnAdministrator))
            LogHelper.warn(TaskService.LOG_PREFIX, `Unable to load task for id ${idTask}`, error)

            return null
        })

        return promise
    }

    //#endregion


    //#region Save

    public saveTask(task: OpTask, isBulkSave: boolean = false): JQueryPromise<OpTask> {
        return this.userSessionService
            .getDataProvider().Task
            .saveTask(task)
            .then((savedTask: OpTask) => {
                if (!isBulkSave) {
                    ToastHelper.showSuccess(LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__SAVED, TaskService.SIMAX_MODULE_NAME))
                    CommonHelper.setValueToLocalStorage(CommonHelper.localStorageVarForSavedEntity.taskSaved, true, 0)
                }

                return savedTask
            })
            .fail((error: any) => {
                ToastHelper.showError(ConvertHelper.getRequestErrorMessage(error) || LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__SAVE_ERROR, TaskService.SIMAX_MODULE_NAME))
                LogHelper.warn(TaskService.LOG_PREFIX, `Unable to save task with id ${task.idTask}.`, error)

                return $.Deferred().reject(error).promise()
            })
    }

    public saveTaskAttachment(modelId: number, added: OpFile): JQueryPromise<OpFile> {
        return this.userSessionService
            .getDataProvider()
            .Task.saveTaskAttachment(modelId, added)
            .then((data: OpFile) => {
                ToastHelper.showSuccess(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.IssueAttachmentSave))
                return data
            })
            .fail((error: any) => {
                const errorMsg: string = ConvertHelper.getRequestErrorMessage(error)

                ToastHelper.showError(errorMsg || LocalizationHelper.getLocalizedText(LocalizationHelper.Text.IssueAttachmentSaveError))
                LogHelper.log(TaskService.LOG_PREFIX, `Unable to delete attachment. Error: ${errorMsg}.`)

                return $.Deferred<OpFile>().reject(error).promise()
            })
    }

    public saveTaskPayments(paymentObj: PaymentSubmitResult): JQueryPromise<OpTask> {
        paymentObj.formData.idTask = paymentObj.idTask
        paymentObj.formData.opState = Enums.OpChangeState.Modified
        const paymentEqual = (searchedPayment: OpTaskPaymentElement, paymentToCompare: OpTaskPaymentElement): boolean => {
            return searchedPayment.description == paymentToCompare.description && searchedPayment.paymentType == paymentToCompare.paymentType
        }

        return this.userSessionService
            .getDataProvider()
            .Task
            .getTaskPayments(paymentObj.formData.idTask, true)
            .then((payments: OpTaskPaymentElement[]) => {

                if (_.size(paymentObj.added) > 0) {
                    paymentObj.added.forEach((addedElement: OpTaskPaymentElement) => {
                        const payment: OpTaskPaymentElement = _.find(payments, (payment: OpTaskPaymentElement) => paymentEqual(payment, addedElement))
                        payment.notes = addedElement.notes
                        payment.opState = Enums.OpChangeState.New
                        payment.value = addedElement.value
                        payment.indexNbr = _.max(payments, (payment: OpTaskPaymentElement) => payment.indexNbr).indexNbr + 1
                        paymentObj.formData.payments.push(payment)
                    })
                }

                if (_.size(paymentObj.removed) > 0) {
                    paymentObj.removed.forEach((removedElement: OpTaskPaymentElement) => {
                        const payment: OpTaskPaymentElement = _.find(payments, (payment: OpTaskPaymentElement) => paymentEqual(payment, removedElement))
                        if (payment != null) {
                            payment.opState = Enums.OpChangeState.Delete
                            paymentObj.formData.payments.push(payment)
                        }
                    })
                }

                if (_.size(paymentObj.inGrid) > 0) {
                    paymentObj.inGrid.forEach((inGridElement: OpTaskPaymentElement) => {
                        const payment: OpTaskPaymentElement = _.find(paymentObj.removed, (payment: OpTaskPaymentElement) => paymentEqual(payment, inGridElement))
                        if (payment != null) {
                            payment.opState = Enums.OpChangeState.Loaded
                            paymentObj.formData.payments.push(payment)
                        }
                    })
                }

                return this.saveTask(paymentObj.formData)
            })
    }


    //#endregion

    //#region Delete

    public deleteTask(task: OpTask, showToast: boolean = false): JQueryPromise<OpTask> {

        return this.userSessionService
            .getDataProvider()
            .Task
            .deleteTask(task)
            .then((task: OpTask) => {
                if (showToast) {
                    ToastHelper.showSuccess(LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__DELETED, TaskService.SIMAX_MODULE_NAME))
                }

                return task
            })
            .fail((error: any) => {
                const errorMsg: string = ConvertHelper.getRequestErrorMessage(error)
                if (showToast) {
                    ToastHelper.showError(errorMsg || LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__DELETE_ERROR, TaskService.SIMAX_MODULE_NAME))
                }
                LogHelper.log(TaskService.LOG_PREFIX, `Unable to delete task. Error: ${errorMsg}.`)

                return $.Deferred<OpTask>().reject(error).promise()
            })

    }

    public deleteTaskAttachment(modelId: number, removed: number[]): JQueryPromise<void> {

        return this.userSessionService
            .getDataProvider()
            .Task
            .deleteTaskAttachment(modelId, removed)
            .then(() => {
                ToastHelper.showSuccess(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.IssueAttachmentDelete))
            })
            .fail((error: any) => {
                const errorMsg: string = ConvertHelper.getRequestErrorMessage(error)

                ToastHelper.showError(errorMsg || LocalizationHelper.getLocalizedText(LocalizationHelper.Text.IssueAttachmentDeleteError))
                LogHelper.log(TaskService.LOG_PREFIX, `Unable to delete attachment. Error: ${errorMsg}.`)
            })
    }

    // #endregion

    //#region Options

    public getBulkEditInitParams(gridData: any[], columns: any[]): BulkEditInitParams {
        return {
            gridColumns: columns,
            groupReferenceType: null,
            groupReferenceValue: null,
            idReferenceType: TaskService.REFERENCE_TYPE,
            moduleName: TaskService.SIMAX_MODULE_NAME,
            section: null,
            selectedGridRows: gridData,
            useBusinessObjects: true
        }
    }

    public getCreateEditOptions(referenceObjectId: number = 0, referenceObject: OpTask = null): CreateEditInitParams {
        return {
            createEditSelectedTabType: Enums.SimaxCreateEditSelectedTabType.BaseParameters,
            groupReferenceType: null,
            groupReferenceValue: null,
            idReferenceType: TaskService.REFERENCE_TYPE,
            moduleName: TaskService.SIMAX_MODULE_NAME,
            referenceObject: referenceObject,
            referenceObjectId: referenceObjectId,
            sections: null,
            useBusinessObjects: true
        }
    }


    //#endregion

    // #region Other

    public changeTaskStatus(ids: number[], taskStatusId: Enums.TaskStatus): JQueryPromise<OpTask[]> {
        return this.userSessionService
            .getDataProvider()
            .Task
            .changeTaskStatus(ids, taskStatusId)
            .then((result: OpTask[]) => {
                ToastHelper.showSuccess(LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__SAVED, TaskService.SIMAX_MODULE_NAME))

                return $.Deferred<OpTask[]>().resolve(result).promise()
            })
            .fail((error: any) => {
                const errorMsg: string = ConvertHelper.getRequestErrorMessage(error)

                ToastHelper.showError(errorMsg || LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__SAVE_ERROR, TaskService.SIMAX_MODULE_NAME))
                LogHelper.log(TaskService.LOG_PREFIX, `Unable to change task status. Error: ${errorMsg}.`)

                return $.Deferred<void>().reject(error).promise()
            })
    }

    public onInstalledEquipmentSubmit(added: any[], removed: any[], inGrid: any[], referenceObject: OpTask): JQueryPromise<OpLocationEquipment[]> {

        let toAdd: OpLocationEquipment[] = []
        let toRemove: OpLocationEquipment[] = []
        return this.getDeviceSerialNumberColumnName()
            .then((columnName: string) => {

                if (removed.length != 0) {
                    toRemove = this.mapRemovedInstalledEqToSave(removed, columnName)
                }

                if (added.length != 0) {
                    toAdd = this.mapAddedInstalledEqToSave(added, columnName, referenceObject)
                }
                return [...toAdd, ...toRemove]
            })
    }

    private mapAddedInstalledEqToSave(added: any[], columnName: string, referenceObject: OpTask): OpLocationEquipment[] {
        return added.map((item: any) => {
            const added: OpLocationEquipment = new OpLocationEquipment(null)
            added.idLocationEquipment = 0
            added.idLocation = referenceObject.idLocation
            added.serialNbr = item[columnName]
            added.startTime = new Date()
            added.endTime = null
            added.idMeter = null
            added.opState = OpChangeState.New
            return added
        })
    }

    private mapRemovedInstalledEqToSave(removed: any[], columnName: string): OpLocationEquipment[] {
        return removed.map((item: any) => {
            const removed: OpLocationEquipment = new OpLocationEquipment(null)
            removed.idLocationEquipment = 0
            removed.idLocation = 0
            removed.serialNbr = item[columnName]
            removed.startTime = new Date()
            removed.endTime = null
            removed.idMeter = null
            removed.opState = OpChangeState.New
            return removed
        })
    }

    public onUninstalledEquipmentSubmit(added: any[], removed: any[], inGrid: any[], referenceObject: OpTask): JQueryPromise<OpLocationEquipment[]> {
        return this.getDeviceSerialNumberColumnName()
            .then((columnName: string) => {
                let toAdded: OpLocationEquipment[] = []
                let toRemove: OpLocationEquipment[] = []
                if (removed.length != 0) {
                    toRemove = this.mapRemovedUnistalledEqToSave(removed, columnName, referenceObject);
                }
                if (added.length != 0) {
                    toAdded = this.mapAddedUnistalledEqToSave(added, columnName);
                }

                return [...toRemove, ...toAdded]
            })
    }

    private mapAddedUnistalledEqToSave(added: any[], columnName: string): OpLocationEquipment[] {
        return added.map((item: OpLocationEquipment) => {
            const added: OpLocationEquipment = new OpLocationEquipment(null)
            added.idLocationEquipment = 0
            added.idLocation = 0 // Przenosimy na magazyn operatora
            added.serialNbr = item[columnName]
            added.startTime = new Date()
            added.endTime = null
            added.idMeter = null
            added.opState = OpChangeState.New
            return added
        })
    }

    private mapRemovedUnistalledEqToSave(removed: any[], columnName: string, referenceObject: OpTask): OpLocationEquipment[] {
        return removed.map((item: OpLocationEquipment) => {
            const removed: OpLocationEquipment = new OpLocationEquipment(null)
            removed.idLocationEquipment = 0
            removed.idLocation = referenceObject.idLocation
            removed.serialNbr = item[columnName]
            removed.startTime = new Date()
            removed.endTime = null
            removed.idMeter = item.idMeter
            removed.opState = OpChangeState.New
            return removed
        })
    }

    // #endregion

}

export class TaskServiceProvider implements ng.IServiceProvider {

    //#region IServiceProvider Implementation 

    public $get = [
        USER_SESSION_SERVICE_NAME,
        MAP_SERVICE_NAME,
        GRID_SERVICE_NAME,
        function (
            userSessionService: UserSessionService,
            mapService: MapService,
            gridService: GridService
        ) {
            return new TaskService(userSessionService, mapService, gridService)
        }]

    //#endregion
} 